/**
 * GNS (Global Namespace System)
 * すべてのクラスとユーティリティを含むグローバルコンテナ
 */
export var GNS = {};
window.GNS = GNS;
